import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { IonRadio } from '@ionic/angular/standalone';

@Component({
    selector: 'lib-radio',
    standalone: true,
    imports: [CommonModule, IonRadio],
    templateUrl: './radio.component.html',
    styleUrl: './radio.component.css'
})
export class RadioComponent {
    @Input() value: string | number | undefined;
    @Input() disabled: boolean = false;
}
